import React from 'react'

/* doc
---
title: CardFooterItem
name: CardFooterItem
category: React - Bulma
parent: CardFooter
---

A `CardFooterItem` component for adding content to the footer.

If you want the entire item to be a clickable link, use the `Link` component
with a class of `.card-footer-item`,
eg: `<Link href="" className="card-footer-item>Stuff</Link>"`

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
<Card>
  ...
  <CardFooter>
    <CardFooterItem>...</CardFooterItem>
    <CardFooterItem>...</CardFooterItem>
    <CardFooterItem>...</CardFooterItem>
  </CardFooter>
</Card>
```
*/
function CardFooterItem(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-footer-item',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default CardFooterItem
